/* eslint-disable @typescript-eslint/naming-convention */
import clsx from 'clsx'
import {
  BasicStyledComponent,
  DSFeatureIcon,
  DSProductFeatureProps,
} from 'shared-definitions/types'
import Barcode from 'shared-svg/Barcode.svg'
import Dimensions from 'shared-svg/Dimensions.svg'
import Drop from 'shared-svg/Drop.svg'
import Dumbbell from 'shared-svg/Dumbbell.svg'
import SquaredCheck from 'shared-svg/SquaredCheck.svg'
import StackedCoins from 'shared-svg/StackedCoins.svg'
import Battery from 'shared-svg/Battery.svg'
import Microphone from 'shared-svg/Microphone.svg'
import Headphone from 'shared-svg/Headphone.svg'
import Noisy from 'shared-svg/Noise.svg'
import Charger from 'shared-svg/Charger.svg'
import MusicNote from 'shared-svg/MusicNote.svg'
import NetworkQuality from 'shared-svg/NetworkQuality.svg'
import AllAround from 'shared-svg/AllAround.svg'
import styles from './ProductFeature.module.css'
import { htmlReactParse } from 'shared-code/html'

const componentsMap: Record<DSFeatureIcon, React.VFC<BasicStyledComponent>> = {
  '3d': AllAround,
  network_bars: NetworkQuality,
  noisy: Noisy,
  music_note: MusicNote,
  headphones: Headphone,
  charger: Charger,
  battery: Battery,
  microphone: Microphone,
  'checkmark-screen': SquaredCheck,
  coins: StackedCoins,
  dumbbell: Dumbbell,
  dimensions: Dimensions,
  drop: Drop,
  barcode: Barcode,
}

interface ProductFeatureProps extends BasicStyledComponent {
  feature: DSProductFeatureProps
}

const ProductFeature: React.VFC<ProductFeatureProps> = ({ feature, className }) => {
  const Svg = componentsMap[feature.prop] ?? SquaredCheck
  return (
    <div className={clsx(styles.container, className)}>
      <Svg className={styles.icon} />
      <div className={styles.desc}>{feature.desc}</div>
      <div className={styles.val}>
        {feature.val.map((item, index) => (
          <div key={index}>{htmlReactParse(item)}</div>
        ))}
      </div>
    </div>
  )
}

export default ProductFeature
